import { ReactNode } from 'react';
import { Icon, Surface, Txt } from '@vst/beam';
import { Check } from '@vst/beam-icons/icons';

const PlanAttribute = ({ children }: { children: ReactNode }) => {
  return (
    <Surface py={'4px'}>
      <Icon icon={Check} />
      <Txt component="span" variant={'bodyLargeRegular'} ml={'8px'} mr={'8px'}>
        {children}
      </Txt>
    </Surface>
  );
};
export default PlanAttribute;
